import { Action } from 'redux';
import { TriageRegistrationConfig } from '@eql-ai/typescript-types';
import { ConfigRequestStatus } from '../types';

export enum TriageRegistrationConfigActionTypes {
    SET_TRIAGE_REGISTRATION_CONFIG = 'SET_TRIAGE_REGISTRATION_CONFIG',
    SET_TRIAGE_REGISTRATION_CONFIG_WITH_PROVIDER_ROUTE = 'SET_TRIAGE_REGISTRATION_CONFIG_WITH_PROVIDER_ROUTE',
    SET_TRIAGE_REGISTRATION_CONFIG_REQUEST_STATUS = 'SET_TRIAGE_REGISTRATION_CONFIG_REQUEST_STATUS',
}

export interface TriageRegistrationConfigState {
    isLoadingProviderConfig: boolean;
    requestStatus: ConfigRequestStatus | null;
    config: TriageRegistrationConfig | null;
}

export interface SetTriageRegistrationConfigAction extends Action {
    type: TriageRegistrationConfigActionTypes.SET_TRIAGE_REGISTRATION_CONFIG;
    payload: TriageRegistrationConfig | null;
}

export interface SetTriageRegistrationConfigWithProviderRouteAction
    extends Action {
    type: TriageRegistrationConfigActionTypes.SET_TRIAGE_REGISTRATION_CONFIG_WITH_PROVIDER_ROUTE;
    payload: string | null;
}

export interface SetRequestStatusAction extends Action {
    type: TriageRegistrationConfigActionTypes.SET_TRIAGE_REGISTRATION_CONFIG_REQUEST_STATUS;
    payload: ConfigRequestStatus;
}

export type TriageRegistrationConfigReducerAction =
    | SetTriageRegistrationConfigAction
    | SetTriageRegistrationConfigWithProviderRouteAction
    | SetRequestStatusAction;
